import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';
import { Image } from '@consumer-frontend/shared-ui';

import { NcRadioButton, NcRadioButtonPropsT } from '../NcRadioButton';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/form/radio-card.scss';

export type NcRadioCardPropsT = NcRadioButtonPropsT & {
  activeIcon: string;
  alt: string;
  icon: string;
};

export const NcRadioCard = ({
  activeIcon,
  alt,
  checked,
  className,
  icon,
  label,
  ...props
}: NcRadioCardPropsT) => {
  const classNameProp = mergeClassNameStrings('nc-radio-card', className);

  return (
    <NcRadioButton
      {...props}
      checked={checked}
      className={classNameProp}
      label={
        <>
          <Image
            src={checked ? activeIcon : icon}
            alt={alt}
            className="nc-radio-card-icon"
          />
          <span className="nc-radio-card-label">{label}</span>
        </>
      }
    />
  );
};
